import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AppSettingsService } from "../app-settings-service/app-settings.service";
import { AuthService } from "../auth";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { AnalyticsService } from "../analytics-service/analytics.service";

export const authGuard: CanActivateFn = async () => {
    const iframeMessagesService = inject(IframeMessagesService);
    const auth = inject(AuthService);
    const router = inject(Router);
    const analyticsService = inject(AnalyticsService);
    const appSettingsService = inject(AppSettingsService);

    let currentUser;
    try {
        currentUser = await auth.getCurrentUser();
    } catch (exception) {
        console.error("Login failure:", exception);
        return router.createUrlTree(["accessdenied"]);
    }

    analyticsService.track("User login - Internal - Web-app", {
        UserID: currentUser.sub,
    });

    if (currentUser?.firm_id) {
        if (
            !(
                currentUser.ifirm_url === iframeMessagesService.messagesOrigin() ||
                (appSettingsService.getSetting("LocalVM_URL") && currentUser.ifirm_url === appSettingsService.getSetting("LocalVM_URL"))
            )
        ) {
            analyticsService.track("User login - Token mismatch", { TokenUrl: currentUser.ifirm_url });
            return router.createUrlTree(["accessdenied"]);
        } else {
            return true;
        }
    } else {
        return router.createUrlTree(["accessdenied"]);
    }
};
